import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'mat-error[shared-form-error]',
  templateUrl: './form-error.component.html',
  styleUrl: './form-error.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FormErrorComponent {
  @Input() control?: AbstractControl | null;
  @Input() type: 'input' | 'select' | 'mobileNumber' = 'input';
}
